import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Constants } from "../assets/utils/lib/constants";

export interface ILayoutProps {
    pageTitle?: string;
    subtitle?: string;
    communityName?: string;
    isServiceRequestEnabled?: boolean;
    isSingleCommunityUser?: boolean;
};


const initialState: ILayoutProps = {
    pageTitle: Constants.emptyString,
    subtitle: Constants.emptyString,
    communityName: Constants.emptyString,
    isServiceRequestEnabled: undefined,
    isSingleCommunityUser: undefined,
};

export const layoutStore = createSlice({
    name: "layoutStore",
    initialState,
    reducers: {
        UpdatePageTitle: (state, action: PayloadAction<string>) => {
            state.pageTitle = action.payload;
        },
        UpdatePageSubtitle: (state, action: PayloadAction<string | undefined>) => {
            state.subtitle = action.payload;
        },
        UpdateSideNavbarCommunityName: (state, action: PayloadAction<string | undefined>) => {
            state.communityName = action.payload ?? "Communities";
        },
        UpdateServiceRequestEnabled: (state, action: PayloadAction<boolean | undefined>) => {
            state.isServiceRequestEnabled = action.payload;
        },
        UpdateHasSingleCommunity(state, action) {
            state.isSingleCommunityUser = action.payload;
        }
    },
});

export const { UpdatePageTitle, UpdatePageSubtitle, UpdateSideNavbarCommunityName, UpdateServiceRequestEnabled, UpdateHasSingleCommunity } = layoutStore.actions;
export default layoutStore.reducer;
